import { getAuthCode } from "./getAuthCode";
export const deleteAccount = async () => {
  let endpointUrl = process.env.REACT_APP_BACKEND_URL + "/deleteAccount"; 
  try {
    const response = await fetch(endpointUrl, {
      method: "POST", // Should match your server-side route method
      credentials: 'include',
      headers: {
        "Content-Type": "application/json",
      },
      body:JSON.stringify({auth_code:await getAuthCode()})
    });
    if (!response.ok) {
      console.log(response);
    }
    if(response.ok){
      window.location.href = '/';
    }
  } catch (error) {
    // Handle network or other errors
    console.error("Error:", error.message);
  }
};